<template>
    <v-container fluid>
        
      <v-card :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}" flat :dark="$store.getters.getColorPalette().isDark" >
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$store.getters.getTextMap().search"
            single-line
            hide-details
            :dark="$store.getters.getColorPalette().isDark" 
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="departments"
          item-key="department_id"
          :search="search"
          :single-expand="true"
          show-expand
          :expanded.sync="expanded"
          :loading="loading"
        loading-text="Loading... Please wait"
       :dark="$store.getters.getColorPalette().isDark" 
        >
        <template v-slot:top>
          <v-toolbar
            flat
            :dark="$store.getters.getColorPalette().isDark" 
          >
            <v-toolbar-title>{{ $store.getters.getTextMap().department }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <CreateDepartmentModal v-if="
        $store.state.user &&
        $store.state.settingMode &&
        $store.getters.getAccessByLevels(['engineeraccess'])
      " />
              </v-toolbar>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <Department :department="item" />
           
          </td>
        </template>
              
        </v-data-table>
      </v-card>
    </v-container>
    </template>
    
    <script>
    import CreateDepartmentModal from '@/components/modals/CreateDepartmentModal'
    import Department from '@/components/items/Department'
    // import ColorUtility from '@/utillities/ColorUtility'
    export default {
        name:'DepartmentTable',
        components:{
            CreateDepartmentModal,
            Department
        },
        data(){
            return {
                search:'',
                loading:false,
                expanded: [],
                headers: [
              {
                text: 'ID',
                align: 'start',
                filterable: false,
                value: 'department_id',
                class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName
              },
              { text: 'Name', value: 'department_name', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              { text: 'Description', value: 'details', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
              
              
            ],
            }
        },
        computed:{
            departments(){
                //console.log(this.$store.getters.getNodesByWorkspaceId(this.workspace.workspace_id))
                return this.$store.getters.getDepartments()
            }
        },
    }
    </script>
    <style scoped>
    
    .v-card__title{
      background-color:#BDBDBD00;
    }
    .theme--light.v-toolbar.v-sheet{
      background-color: #B2DFDB00;
    }
    .theme--light.v-data-table{
       background-color: #B2DFDB00;
    }
    </style>